<template>
    <v-dialog
        v-model="$store.state.concil.genericReport"
        transition="dialog-bottom-transition"
        persistent
        width="1800"
    >
        <v-container fluid style="padding: 0;overflow: hidden;">
            <v-card>
                <v-toolbar
                    dark
                    color="secondary"
                    dense
                    style="margin-bottom: 15px;"
                >
                    <v-btn icon dark @click="getReport('xlsx')">
                        <v-icon>mdi-microsoft-excel</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-toolbar-title class="white--text">
                        {{ ReportData.Params.Report.Name }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        icon
                        dark
                        @click="$store.state.concil.genericReport = false"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-row style="padding: 20px 50px 30px;">
                    <v-col cols="12">
                        <v-card style="padding-top: 10px;" v-if="render">
                            <v-card-title
                                style="padding-top: 20px;padding-bottom: 30px;"
                            >
                                <template
                                    v-if="
                                        ReportData.Params.Report.Alias ===
                                            'InvoiceSummary'
                                    "
                                >
                                    <v-card outlined style="margin: 0 20px;">
                                        <v-card-title style="padding: 5px 10px;"
                                            >Symbology</v-card-title
                                        >
                                        <v-card-text>
                                            <v-chip
                                                class="ma-2"
                                                color="#ABEBC6"
                                                text-color="#1A1A1A"
                                            >
                                                <v-icon left>
                                                    mdi-scale-balance
                                                </v-icon>
                                                Reconciled
                                            </v-chip>
                                            <v-tooltip top>
                                                <template
                                                    v-slot:activator="{
                                                        on,
                                                        attrs
                                                    }"
                                                >
                                                    <v-chip
                                                        class="ma-2"
                                                        color="#FDD835"
                                                        text-color="#1A1A1A"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                    >
                                                        <v-icon left>
                                                            mdi-scale-unbalanced
                                                        </v-icon>
                                                        Reconciled But No
                                                        Matches
                                                    </v-chip>
                                                </template>
                                                <span>Difference greater or less than zero</span>
                                            </v-tooltip>
                                            <v-chip
                                                class="ma-2"
                                                color="#F5B7B1"
                                                text-color="#1A1A1A"
                                            >
                                                <v-icon left>
                                                    mdi-dots-horizontal-circle
                                                </v-icon>
                                                Pending reconciliation
                                            </v-chip>
                                        </v-card-text>
                                    </v-card>
                                    <v-select
                                        v-model="sortBy"
                                        dense
                                        hide-details
                                        :items="headersKeys"
                                        outlined
                                        prepend-inner-icon="mdi-magnify"
                                        label="Sort by"
                                        @change="handleSortData"
                                        style="margin-right: 20px;"
                                    ></v-select>
                                    <v-btn-toggle
                                        v-model="sortDesc"
                                        mandatory
                                        @change="handleSortData"
                                    >
                                        <v-btn
                                            small
                                            dense
                                            depressed
                                            color="blue"
                                            :value="false"
                                        >
                                            <v-icon>mdi-arrow-up</v-icon>
                                        </v-btn>
                                        <v-btn
                                            small
                                            dense
                                            depressed
                                            color="blue"
                                            :value="true"
                                        >
                                            <v-icon>mdi-arrow-down</v-icon>
                                        </v-btn>
                                    </v-btn-toggle>
                                </template>
                                <v-text-field
                                    v-model="reportSearch"
                                    append-icon="mdi-magnify"
                                    label="Search here"
                                    hide-details
                                    style="padding-top: 0;margin-top: 0;margin-left: 30px;"
                                ></v-text-field>
                            </v-card-title>
                            <v-data-table
                                :headers="fmtReportData.Data.Headers"
                                :items="fmtReportData.Data.Main"
                                dense
                                fixed-header
                                :search="reportSearch"
                                :height="
                                    ReportData.Params.Report.Alias ===
                                    'InvoiceSummary'
                                        ? 800
                                        : unset
                                "
                                :item-class="itemRowBackground"
                                :disable-sort="
                                    ReportData.Params.Report.Alias ===
                                        'InvoiceSummary'
                                "
                            >
                                <template
                                    v-slot:item.BillOfLading="{ item }"
                                    v-if="checkBOLDetailsByReportList()"
                                >
                                    <td>
                                        <v-btn
                                            color="primary"
                                            dark
                                            small
                                            @click="openBOLDetails(item)"
                                        >
                                            {{ item.BillOfLading }}
                                        </v-btn>
                                    </td>
                                </template>
                                <template slot="body.append">
                                    <tr>
                                        <td
                                            v-for="(hd, idx) in fmtReportData
                                                .Data.Headers"
                                            :key="idx"
                                        >
                                            <strong
                                                v-if="
                                                    fmtReportData.Data
                                                        .Totals[0][hd.value] !==
                                                        undefined &&
                                                        fmtReportData.Data
                                                            .Totals[0][
                                                            hd.value
                                                        ] !== '$NaN'
                                                "
                                                class="text-left font-weight-bold"
                                            >
                                                {{
                                                    fmtReportData.Data
                                                        .Totals[0][hd.value]
                                                }}
                                            </strong>
                                            <strong
                                                v-else
                                                class="text-left font-weight-bold"
                                            ></strong>
                                        </td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-card>
        </v-container>

        <ConcilBOLDetails
            v-if="$store.state.concil.bolDetails"
            :DataBOLDetails="dataBOLDetails"
            :CallUpdate="false"
        ></ConcilBOLDetails>
    </v-dialog>
</template>

<script>
import axios from 'axios';
//import * as XLSX from 'xlsx';
import ConcilBOLDetails from './ConcilBOLDetails.vue';

export default {
    props: ['ReportData'],
    components: {
        ConcilBOLDetails
    },
    data: function() {
        return {
            reportSearch: '',
            filename: '',
            render: false,
            fmtReportData: {},
            headersKeys: [],
            sortBy: '',
            sortDesc: false,
            dataBOLDetails: null
        };
    },
    mounted() {
        this.prepareData();
    },
    methods: {
        handleSortData: function() {
            console.log(this.sortBy);
            console.log(this.sortDesc);
            console.log(this.ReportData.Data.Main);

            if (this.sortBy !== '') {
                if (this.sortDesc) {
                    this.ReportData.Data.Main = this.ReportData.Data.Main.sort(
                        (a, b) => {
                            if (this.sortBy == 'InvDate') {
                                let dateA = new Date(a[this.sortBy]);
                                let dateB = new Date(b[this.sortBy]);
                                return dateB - dateA;
                            } else if (this.sortBy == 'InvId') {
                                return (
                                    parseInt(b[this.sortBy]) -
                                    parseInt(a[this.sortBy])
                                );
                            } else {
                                return (
                                    parseFloat(b[this.sortBy]) -
                                    parseFloat(a[this.sortBy])
                                );
                            }
                        }
                    );
                } else {
                    this.ReportData.Data.Main = this.ReportData.Data.Main.sort(
                        (a, b) => {
                            if (this.sortBy == 'InvDate') {
                                let dateA = new Date(a[this.sortBy]);
                                let dateB = new Date(b[this.sortBy]);
                                return dateA - dateB;
                            } else if (this.sortBy == 'InvId') {
                                return (
                                    parseInt(a[this.sortBy]) -
                                    parseInt(b[this.sortBy])
                                );
                            } else {
                                return (
                                    parseFloat(a[this.sortBy]) -
                                    parseFloat(b[this.sortBy])
                                );
                            }
                        }
                    );
                }

                this.formatData();
            } else {
                console.log('Select sort by');
                this.$store.dispatch('setSnackbar', {
                    color: 'warning',
                    text: 'Select sort by'
                });
            }
        },
        prepareData: function() {
            console.log(this.ReportData.Data);

            if (this.ReportData.Params.Report.Alias === 'InvoiceSummary') {
                this.ReportData.Data.Headers.forEach(h =>
                    this.headersKeys.push(h.value)
                );
                console.log(this.headersKeys);
            }

            this.formatData();
        },
        formatData: function() {
            this.fmtReportData = JSON.parse(JSON.stringify(this.ReportData));
            let cad = new Intl.NumberFormat('en-CA', {
                style: 'currency',
                currency: 'CAD'
            });

            this.fmtReportData.Data.Main.forEach(row => {
                this.fmtReportData.Data.CurrencyFormat.forEach(fmt => {
                    row[fmt] = cad.format(row[fmt]);
                });
            });

            this.fmtReportData.Data.Totals.forEach(row => {
                this.fmtReportData.Data.CurrencyFormat.forEach(fmt => {
                    row[fmt] = cad.format(row[fmt]);
                });
            });

            console.log(this.fmtReportData);
            this.render = true;
        },
        setParams: function(requestType) {
            let params = {
                Customer: this.ReportData.Params.Customer,
                Report: this.ReportData.Params.Report,
                SearchBy: this.ReportData.Params.SearchBy,
                Data: this.ReportData.Data,
                Headers: this.ReportData.Data.ExcelHeaders
            };

            if (this.ReportData.Params.SearchBy == 'date-range') {
                this.filename =
                    'Rec_' +
                    this.ReportData.Params.Customer.Alias +
                    '_' +
                    this.ReportData.Params.Report.Alias +
                    '_' +
                    this.ReportData.Params.StartDate +
                    '_' +
                    this.ReportData.Params.EndDate +
                    '.' +
                    requestType;
                params.Filename = this.filename;
                params.StartDate = this.ReportData.Params.StartDate;
                params.EndDate = this.ReportData.Params.EndDate;
            } else if (this.ReportData.Params.SearchBy == 'file') {
                this.filename =
                    'Rec_' +
                    this.ReportData.Params.Customer.Alias +
                    '_' +
                    this.ReportData.Params.Report.Alias +
                    '.' +
                    requestType;
                params.Filename = this.filename;
                params.File = this.ReportData.Params.File;
            }

            console.log(params);
            return params;
        },
        getReport: async function(requestType) {
            let str = this.$store;
            str.state.isLoading = true;
            let params = this.setParams(requestType);
            await axios
                .post('conciliation/get/report/' + requestType, params, {
                    headers: {
                        Authorization: 'Bearer ' + this.$store.state.token
                    },
                    responseType: 'blob'
                })
                .then(response => {
                    let data = response.data;
                    let url = window.URL.createObjectURL(new Blob([data]));
                    let link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.filename);
                    document.body.appendChild(link);
                    link.click();
                    str.state.isLoading = false;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        },
        itemRowBackground: function(item) {
            if (this.ReportData.Params.Report.Alias === 'InvoiceSummary') {
                let rawItem = this.ReportData.Data.Main.filter(itm => itm.InvId == item.InvId);

                if (rawItem[0] !== undefined) {
                    if (
                        item.IsReconciled &&
                        rawItem[0].Diff != null &&
                        (
                            rawItem[0].Diff > -0.1 &&
                            rawItem[0].Diff < 0.1
                        )
                    ) {
                        return 'is-reconciled';
                    } else if (
                        item.IsReconciled &&
                        rawItem[0].Diff != null &&
                        (
                            rawItem[0].Diff <= -0.1 ||
                            rawItem[0].Diff >= 0.1
                        )
                    ) {
                        return 'is-reconciled-but-no-matches';
                    } else if (!item.IsReconciled) {
                        return 'is-pending-reconciliation';
                    } else {
                        return 'transparent-row';
                    }
                } else {
                    return 'transparent-row';
                }
            } else {
                return 'transparent-row';
            }
        },
        checkBOLDetailsByReportList: function() {
            let reportList = ['OutstandingBOLsByAmount'];

            if (reportList.includes(this.ReportData.Params.Report.Alias)) {
                return true;
            } else {
                return false;
            }
        },
        openBOLDetails: async function(item) {
            let str = this.$store;
            str.state.isLoading = true;
            let params = {
                Customer: this.ReportData.Params.Customer,
                BOL: item.BillOfLading,
                DeliveryDate: item.DateDelivered
            };

            console.log(params);
            await axios
                .post('conciliation/get/bol-details', params)
                .then(response => {
                    this.dataBOLDetails = {
                        Data: response.data,
                        Params: params
                    };
                    str.state.isLoading = false;
                    str.state.concil.bolDetails = true;
                })
                .catch(function(error) {
                    console.log(error);
                    str.state.isLoading = false;
                });
        }
    }
};
</script>

<style>
    .is-reconciled {
        background-color: #ABEBC6!important;
    }
    .is-pending-reconciliation {
        background-color: #F5B7B1!important;
    }
    .is-reconciled-but-no-matches {
        background-color: #FDD835!important;
    }
    .transparent-row {
        background-color: transparent;
    }
    .v-data-table tbody tr:last-child td {
        position: sticky;
        bottom: 0;
        background-color: white;
        z-index: 1;
    }
    /*.general-tbl, .general-tbl-data {
        border-collapse: collapse;
        width: 100%;
    }
    .general-tbl th, .general-tbl-data th {
        text-align: left;
        font-size: 12px;
    }
    .general-tbl th:hover {
        background-color: #7892b1;
    }
    .general-tbl-data th { 
        background-color: #fff;
        font-weight: 500;
    }

    .sub-tbl th, .sub-tbl td {
        padding: 8px;
        text-align: left;
    }
    .sub-tbl th {
        font-size: 12px;
        background-color: #fff;
    }
    .sub-tbl td:hover {
        background-color: #e1e1e1;
    }
    .grid-container {
        display: grid;
        grid-template-columns: 1fr 3fr 3fr 4fr 4fr 3fr 4fr 4fr;
        align-items: center;
    }*/
</style>
